import React, { useEffect, useState } from 'react';

const KekaJobsEmbed = () => {
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        console.log("KekaJobsEmbed: Component mounted, initializing...");

        // 1. Set configuration globally
        window.khConfig = {
            identifier: '24f6aba6-2550-4a60-98c6-cb033451a61a',
            domain: 'https://ahamhousing.keka.com/careers/',
            targetContainer: '#khembedjobs'
        };

        const scriptSource = "https://ahamhousing.keka.com/careers/api/embedjobs/js/24f6aba6-2550-4a60-98c6-cb033451a61a";

        // 2. Check for existing script and remove to force fresh execution
        const existingScript = document.querySelector(`script[src="${scriptSource}"]`);

        if (existingScript) {
            console.log("KekaJobsEmbed: Script already exists, replacing with fresh instance...");
            existingScript.remove();
        }

        // 3. Create fresh script
        const script = document.createElement('script');
        script.src = scriptSource;
        script.defer = true;

        script.onload = () => {
            console.log("KekaJobsEmbed: Keka script loaded.");
            // Hide loader after a small delay to allow script to start rendering
            setTimeout(() => {
                setIsLoading(false);
            }, 500);
        };

        script.onerror = (e) => {
            console.error("KekaJobsEmbed: Keka script failed to load.", e);
            setIsLoading(false);
        };

        console.log("KekaJobsEmbed: Appending script to page body...");
        document.body.appendChild(script);

        return () => {
            console.log("KekaJobsEmbed: Component unmounting, cleaning up config.");
            delete window.khConfig;
        };
    }, []);

    return (
        <div className="w-full bg-white rounded-lg shadow-inner min-h-[600px] border border-gray-100 overflow-hidden relative">
            {/* Conditional Loader */}
            {isLoading && (
                <div className="absolute inset-0 z-20 bg-white flex flex-col items-center justify-center p-20 text-gray-400">
                    <div className="w-10 h-10 border-4 border-primary-200 border-t-primary-600 rounded-full animate-spin mb-4"></div>
                    <p className="text-sm font-medium">Connecting to Keka Career Portal...</p>
                    <p className="text-xs mt-3 text-gray-300 text-center">
                        If this takes too long, please ensure <b>ahamhfc.com</b> is whitelisted in your Keka Admin Panel.
                    </p>
                </div>
            )}

            {/* Inject custom styles to hide Keka branding/footer */}
            <style>
                {`
                    #khembedjobs .kh-footer,
                    #khembedjobs .kh-branding,
                    #khembedjobs .kh-powered-by {
                        display: none !important;
                    }
                    /* Optional: Remove extra space at bottom */
                    #khembedjobs .kh-container {
                        padding-bottom: 0 !important;
                    }
                `}
            </style>

            {/* Target DIV for Keka portal - Keep it empty and always present */}
            <div id="khembedjobs" className="relative z-10 w-full"></div>
        </div>
    );
};

export default KekaJobsEmbed;
